import { ThemeProvider as DsThemeProvider } from '@descomplica/design-system-react';
import { ThemeProvider } from '@descomplica/foundation-ui-components';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { FC } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastContainer } from 'react-toastify';

import { FullPageError } from './components/FullPageError';
import { FullPageLoading } from './components/FullPageLoading';
import { MicrofrontendViewModel } from './Microfrontend.vm';
import { Router } from './router';

const Microfrontend: FC = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <DsThemeProvider library="core" theme="light">
        <ThemeProvider theme="light">
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <SplashScreen />
        </ThemeProvider>
      </DsThemeProvider>
    </GoogleReCaptchaProvider>
  );
};

const SplashScreen = observer(() => {
  const vm = useViewModel(MicrofrontendViewModel);

  if (vm.isLoading) {
    return <FullPageLoading />;
  }

  if (vm.error) {
    return (
      <FullPageError errorMessage="Oops! Ocorreu uma falha ao tentar iniciar a aplicação. Tente novamente!" />
    );
  }

  return <Router />;
});

export default observer(Microfrontend);
